(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lp-2tone-buyblock"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (root.dataset.lp2tInit === '1') return;
    root.dataset.lp2tInit = '1';

    var dataEl = root.querySelector('[data-lp2tone-data]');
    var DATA;
    try { DATA = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var settings = DATA.labels || { ctaSingle: 'カートに入れる', ctaPair: 'ペアでカートに入れる', pairProp: 'おそろい便', soldout: '在庫切れ', stickyChoose: '色を選ぶ' };

    var state = { size: '330', mode: 'single', single: null, pair1: null, pair2: null };

    var els = {
      sizeSeg: root.querySelector('[data-lp2t-size]'),
      modeBtns: root.querySelectorAll('[data-lp2t-mode] [data-mode]'),
      singleWrap: root.querySelector('[data-lp2t-single]'),
      pairWrap: root.querySelector('[data-lp2t-pair]'),
      price: root.querySelector('[data-lp2t-price]'),
      cta: root.querySelector('[data-lp2t-cta]'),
      err: root.querySelector('[data-lp2t-error]'),
      preview: root.querySelector('[data-lp2t-preview]'),
      sticky: root.querySelector('[data-lp2t-sticky]'),
      stickyPrice: root.querySelector('[data-lp2t-sticky-price]'),
      stickyBtn: root.querySelector('[data-lp2t-sticky-btn]'),
      grids: {
        single: root.querySelector('[data-lp2t-grid="single"]'),
        pair1: root.querySelector('[data-lp2t-grid="pair1"]'),
        pair2: root.querySelector('[data-lp2t-grid="pair2"]')
      },
      sel: {
        single: root.querySelector('[data-lp2t-sellabel="single"]'),
        pair1: root.querySelector('[data-lp2t-sellabel="pair1"]'),
        pair2: root.querySelector('[data-lp2t-sellabel="pair2"]')
      }
    };

    function yen(n) { return '¥' + Number(n).toLocaleString('ja-JP'); }
    function sizeData() { return DATA[state.size]; }
    function variantByColor(size, color) {
      var arr = DATA[size].variants, i;
      for (i = 0; i < arr.length; i++) { if (arr[i].color === color) return arr[i]; }
      return null;
    }
    function uuid() {
      if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (Math.random() * 16) | 0, v = c === 'x' ? r : (r & 0x3) | 0x8; return v.toString(16);
      });
    }

    function buildSizes() {
      els.sizeSeg.innerHTML = '';
      ['330', '190'].forEach(function (sz) {
        var d = DATA[sz];
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'lp2t__seg-btn' + (sz === state.size ? ' is-active' : '');
        b.setAttribute('role', 'radio');
        b.setAttribute('aria-checked', sz === state.size ? 'true' : 'false');
        b.dataset.size = sz;
        b.textContent = d.label + ' ' + yen(d.price);
        b.addEventListener('click', function () { setSize(sz); });
        els.sizeSeg.appendChild(b);
      });
    }

    function buildGrid(key) {
      var grid = els.grids[key];
      if (!grid) return;
      grid.innerHTML = '';
      sizeData().variants.forEach(function (v) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'lp2t__sw';
        btn.setAttribute('role', 'radio');
        btn.dataset.color = v.color;
        if (!v.available) { btn.disabled = true; btn.setAttribute('aria-disabled', 'true'); }
        btn.setAttribute('aria-checked', state[key] === v.color ? 'true' : 'false');
        if (state[key] === v.color) btn.classList.add('is-selected');
        btn.title = v.color + (v.available ? '' : '（' + settings.soldout + '）');
        var img = document.createElement('img');
        img.src = v.img || sizeData().fallbackImg || '';
        img.alt = v.color;
        img.loading = 'lazy'; img.width = 120; img.height = 120;
        btn.appendChild(img);
        var nm = document.createElement('span');
        nm.className = 'lp2t__sw-name';
        nm.textContent = v.color.split(' ')[0];
        btn.appendChild(nm);
        if (v.available) {
          btn.addEventListener('click', function () { selectColor(key, v.color); });
        }
        grid.appendChild(btn);
      });
    }

    function selectColor(key, color) {
      state[key] = color;
      buildGrid(key);
      if (els.sel[key]) els.sel[key].textContent = color ? '（' + color + '）' : '';
      var v = variantByColor(state.size, color);
      if (v && v.img) { els.preview.src = v.img; els.preview.alt = color; }
      update();
    }

    function setSize(sz) {
      if (sz === state.size) return;
      state.size = sz;
      buildSizes();
      ['single', 'pair1', 'pair2'].forEach(buildGrid);
      // 選択色は維持（在庫が無ければCTA側で弾く）。プレビュー更新。
      var activeColor = state.mode === 'single' ? state.single : state.pair1;
      if (activeColor) {
        var v = variantByColor(state.size, activeColor);
        if (v && v.img) { els.preview.src = v.img; els.preview.alt = activeColor; }
      }
      update();
    }

    function setMode(mode) {
      state.mode = mode;
      els.modeBtns.forEach(function (b) {
        var on = b.dataset.mode === mode;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      els.singleWrap.hidden = mode !== 'single';
      els.pairWrap.hidden = mode !== 'pair';
      update();
    }

    function resolveSelection() {
      // returns {ok, items, total, msg}
      if (state.mode === 'single') {
        if (!state.single) return { ok: false, msg: '' };
        var v = variantByColor(state.size, state.single);
        if (!v || !v.available) return { ok: false, msg: '選択中の色は現在お選びいただけません。別の色をお選びください。' };
        return { ok: true, total: sizeData().price, items: [{ id: v.id, quantity: 1 }] };
      }
      // pair
      if (!state.pair1 || !state.pair2) return { ok: false, msg: '' };
      var v1 = variantByColor(state.size, state.pair1);
      var v2 = variantByColor(state.size, state.pair2);
      if (!v1 || !v1.available || !v2 || !v2.available) return { ok: false, msg: '選択中の色は現在お選びいただけません。別の色をお選びください。' };
      var pid = uuid();
      var props = {}; props['ペア'] = settings.pairProp; props['_pair_id'] = pid;
      return {
        ok: true,
        total: sizeData().price * 2,
        items: [
          { id: v1.id, quantity: 1, properties: Object.assign({}, props) },
          { id: v2.id, quantity: 1, properties: Object.assign({}, props) }
        ]
      };
    }

    function update() {
      var r = resolveSelection();
      els.cta.textContent = state.mode === 'pair' ? settings.ctaPair : settings.ctaSingle;
      if (state.mode === 'pair') {
        els.price.innerHTML = yen(sizeData().price * 2) + ' <small>（' + yen(sizeData().price) + ' × 2）</small>';
      } else {
        els.price.textContent = yen(sizeData().price);
      }
      els.cta.disabled = !r.ok;
      if (r.msg) { els.err.textContent = r.msg; els.err.hidden = false; } else { els.err.hidden = true; }
      if (els.stickyPrice) els.stickyPrice.textContent = state.mode === 'pair' ? yen(sizeData().price * 2) : yen(sizeData().price);
      if (els.stickyBtn) els.stickyBtn.textContent = r.ok ? (state.mode === 'pair' ? settings.ctaPair : settings.ctaSingle) : settings.stickyChoose;
    }

    function addToCart() {
      var r = resolveSelection();
      if (!r.ok) { update(); return; }
      var root_url = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
      els.cta.classList.add('is-loading'); els.cta.disabled = true;
      fetch(root_url + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: r.items })
      }).then(function (res) {
        if (!res.ok) return res.json().then(function (j) { throw new Error(j.description || 'cart error'); });
        return res.json();
      }).then(function () {
        if (window.dataLayer) {
          try { window.dataLayer.push({ event: 'add_to_cart', value: r.total, num_items: r.items.length, currency: 'JPY' }); } catch (e) {}
        }
        window.location.href = root_url + 'cart';
      }).catch(function (e) {
        els.cta.classList.remove('is-loading'); els.cta.disabled = false;
        els.err.textContent = 'カートに追加できませんでした。時間をおいて再度お試しください。';
        els.err.hidden = false;
      });
    }

    // wire
    buildSizes();
    setMode('single');
    buildGrid('single'); buildGrid('pair1'); buildGrid('pair2');
    // 初期プレビュー
    var first = sizeData().variants[0];
    if (first) els.preview.src = first.img || sizeData().fallbackImg || '';
    els.modeBtns.forEach(function (b) { b.addEventListener('click', function () { setMode(b.dataset.mode); }); });
    els.cta.addEventListener('click', addToCart);
    if (els.stickyBtn) els.stickyBtn.addEventListener('click', function () {
      if (resolveSelection().ok) { addToCart(); }
      else { var t = root.querySelector('.lp2t__panel'); if (t) t.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
    });
    update();
  }

  function boot() {
    document.querySelectorAll('[data-lp2tone]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-lp2tone]'); if (el) init(el);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
